"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
/** Utility class for constructing an Eppo API endpoint URL given a provided baseUrl and query parameters */
class ApiEndpoints {
    constructor(params) {
        var _a;
        this.params = params;
        this.params.baseUrl = (_a = params.baseUrl) !== null && _a !== void 0 ? _a : constants_1.BASE_URL;
    }
    endpoint(resource) {
        var _a;
        const url = new URL(this.params.baseUrl + resource);
        Object.entries((_a = this.params.queryParams) !== null && _a !== void 0 ? _a : {}).forEach(([key, value]) => url.searchParams.append(key, value));
        return url;
    }
    ufcEndpoint() {
        return this.endpoint(constants_1.UFC_ENDPOINT);
    }
    banditParametersEndpoint() {
        return this.endpoint(constants_1.BANDIT_ENDPOINT);
    }
}
exports.default = ApiEndpoints;
//# sourceMappingURL=api-endpoints.js.map